import React from 'react';
import { useNewUI } from 'hooks/useNewUI';

export const V2RouteSwitch = ({ classic, modern }) => {
  const { enabled } = useNewUI();
  return enabled ? modern : classic;
};
